import { Routes } from '@angular/router';

import { GridDemoComponent } from './grid-demo.component';

export const gridRoutes: Routes = [
  { path: 'grid', component: GridDemoComponent },
];



// WEBPACK FOOTER //
// ./src/app/grid/grid.routes.ts